import React from 'react';

import i18n from 'i18n-react';

import ContentHeader from 'components/ContentHeader';
import FastFacts from 'components/FastFacts';

const FastFactsView = () => (
  <div className="contentContainer fastfacts">
    <div className="backgroundImage" />
    <ContentHeader
      header={i18n.translate('nav.promote')}
      subtitle={i18n.translate('pageDescriptions.promote')}
      social
      line
    />
    <FastFacts />
  </div>
);

export default FastFactsView;
